import React, { useCallback, useEffect } from 'react';
import * as Unicons from '@iconscout/react-unicons';
import { Flex, Select, TextInput } from '@mantine/core';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import Button from '../Button';
import { FiClock, FiList, FiX } from 'react-icons/fi';

interface ToolBoxSortingProps {
  placeholder?: string;
  placeholderSelect?: string;
  handleSearch: (data: any) => void;
  handleSelect?: (data: any) => void;
  buttonOnClick?: () => void;
  dropdownOptions?: any[];
  isSortingDate?: boolean;
  withButton?: boolean;
  withSelect?: boolean;
  buttonText?: string;
}

const ToolBoxSorting: React.FC<ToolBoxSortingProps> = ({
  placeholder = 'Search by name',
  placeholderSelect = 'Select data',
  isSortingDate,
  handleSelect,
  handleSearch,
  buttonText = 'Create',
  withButton = true,
  withSelect = false,
  buttonOnClick
}) => {
  const [search, setSearch] = React.useState('');
  const [date, setDate] = React.useState('');
  const [status, setStatus] = React.useState('');

  const [dropdownOptions, setDropdownOptions] = React.useState<any[]>([
    {
      label: 'All Status',
      value: '',
      icon: <FiList size={16} />
    },
    {
      label: 'Approved',
      value: 'Approved',
      icon: <Unicons.UilCheck size={16} />
    },
    {
      label: 'Waiting',
      value: 'Diambil',
      icon: <FiClock size={16} />
    },
    {
      label: 'Rejected',
      value: 'Rejected',
      icon: <FiX size={16} />
    }
  ]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleNEWSearch();
      // Send Axios request here
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [search, date, status]);

  const handleNEWSearch = () => {
    handleSearch({
      search,
      date,
      status
    });
  };

  return (
    <section className="toolbox-container">
      <div className="toolbox-container--left">
        <div className="">
          <Flex align="center">
            <TextInput
              placeholder={placeholder}
              radius="md"
              leftSection={<Unicons.UilSearch />}
              onChange={(e: any) => {
                setSearch(e.target.value);
              }}
            />
            {isSortingDate && (
              <TextInput
                placeholder={placeholder}
                radius="md"
                type="date"
                ml={20}
                onChange={(e: any) => {
                  setDate(e.target.value);
                }}
              />
            )}
          </Flex>
        </div>
        {withSelect && (
          <Select
            disabled={dropdownOptions?.length === 0}
            data={dropdownOptions}
            placeholder={placeholderSelect}
            onChange={(e: any) => {
              setStatus(e);
            }}
            value={status}
          />
        )}
      </div>

      {withButton && <Button onClick={buttonOnClick}>{buttonText}</Button>}
    </section>
  );
};

export default ToolBoxSorting;

function debounce(func: Function, delay: number) {
  let timeoutId: NodeJS.Timeout;
  return function (...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(null, args), delay);
  };
}
